// ============================================================
// API CLIENT — Fetch wrapper for CoreBank REST API
// ============================================================

const BASE = window.location.hostname === 'localhost'
  ? 'http://localhost:3010/api'
  : '/api';

class ApiError extends Error {
  constructor(status, body) {
    super(body?.message || `API error ${status}`);
    this.status = status;
    this.code = body?.code || 'UNKNOWN';
    this.details = body?.details || null;
  }
}

async function request(method, path, body) {
  const { getToken } = await import('./auth.js');
  const token = getToken();
  const opts = {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  };
  if (body !== undefined) opts.body = JSON.stringify(body);

  const res = await fetch(`${BASE}${path}`, opts);
  const data = await res.json().catch(() => null);

  if (!res.ok) {
    throw new ApiError(res.status, data);
  }
  return data;
}

const api = {
  get: (path) => request('GET', path),
  post: (path, body) => request('POST', path, body),
  put: (path, body) => request('PUT', path, body),
  delete: (path, body) => request('DELETE', path, body),
};

export { api, ApiError };
